module.exports = __webpack_public_path__ + "static/media/tooltip.0629e919.png";